import { render, staticRenderFns } from "./SecureBuyingSection.vue?vue&type=template&id=0432850c"
import script from "./SecureBuyingSection.vue?vue&type=script&lang=js"
export * from "./SecureBuyingSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports